import { Check, ChevronRight, CircleDot, Database, FileSearch, ShieldCheck } from "lucide-react"

export function ProductPreview() {
  return (
    <section className="product-preview" aria-label="Example Resolto investigation">
      <div className="preview-topbar">
        <div>
          <span className="preview-reference">RES-1042</span>
          <strong>Paid account still has starter access</strong>
        </div>
        <span className="status-badge status-warning">
          <ShieldCheck aria-hidden="true" />
          Needs approval
        </span>
      </div>
      <div className="preview-layout">
        <aside className="preview-list" aria-label="Example case list">
          <span className="preview-list-label">Case queue</span>
          <div className="preview-case is-active">
            <span className="priority-mark" aria-hidden="true" />
            <div>
              <strong>Atlas Components</strong>
              <span>Paid access missing</span>
            </div>
            <ChevronRight aria-hidden="true" />
          </div>
          <div className="preview-case">
            <span className="priority-mark is-neutral" aria-hidden="true" />
            <div>
              <strong>Meridian Labs</strong>
              <span>Cannot sign in</span>
            </div>
          </div>
          <div className="preview-case">
            <span className="priority-mark is-neutral" aria-hidden="true" />
            <div>
              <strong>Cobalt Freight</strong>
              <span>Report did not generate</span>
            </div>
          </div>
        </aside>
        <section className="preview-timeline" aria-label="Example evidence timeline">
          <span className="preview-list-label">Investigation timeline</span>
          <ol>
            <li>
              <span className="timeline-icon">
                <FileSearch aria-hidden="true" />
              </span>
              <div>
                <strong>Issue classified</strong>
                <p>Billing and entitlement · customer ID found</p>
              </div>
              <Check aria-hidden="true" className="timeline-complete" />
            </li>
            <li>
              <span className="timeline-icon">
                <Database aria-hidden="true" />
              </span>
              <div>
                <strong>Approved records checked</strong>
                <p>Stripe payment, webhook, mapping, entitlement job</p>
              </div>
              <Check aria-hidden="true" className="timeline-complete" />
            </li>
            <li className="is-emphasis">
              <span className="timeline-icon">
                <CircleDot aria-hidden="true" />
              </span>
              <div>
                <strong>Likely cause found</strong>
                <p>The entitlement job ran before an organisation ID was available.</p>
              </div>
              <span className="confidence-label">High confidence</span>
            </li>
          </ol>
        </section>
        <aside className="preview-summary">
          <span className="preview-list-label">Safe next step</span>
          <strong>Retry entitlement update</strong>
          <p>One workspace, one retry, verified after execution.</p>
          <dl>
            <div>
              <dt>Risk</dt>
              <dd>Moderate</dd>
            </div>
            <div>
              <dt>Authority</dt>
              <dd>Operations manager</dd>
            </div>
            <div>
              <dt>Rollback</dt>
              <dd>Compensating action</dd>
            </div>
          </dl>
          <button type="button" className="button button-primary" disabled>
            Preview approval
          </button>
          <small>Example product evidence · no action is executed here</small>
        </aside>
      </div>
    </section>
  )
}
